/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Successful response
 * @export
 * @interface CreateSupportRequest200Response
 */
export interface CreateSupportRequest200Response {
    /**
     * 
     */
    status?: string;
    /**
     * 
     */
    message?: string;
}

/**
 * Check if a given object implements the CreateSupportRequest200Response interface.
 */
export function instanceOfCreateSupportRequest200Response(value: object): value is CreateSupportRequest200Response {
    return true;
}

export function CreateSupportRequest200ResponseFromJSON(json: any): CreateSupportRequest200Response {
    return CreateSupportRequest200ResponseFromJSONTyped(json, false);
}

export function CreateSupportRequest200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateSupportRequest200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'status': json['status'] == null ? undefined : json['status'],
        'message': json['message'] == null ? undefined : json['message'],
    };
}

export function CreateSupportRequest200ResponseToJSON(json: any): CreateSupportRequest200Response {
    return CreateSupportRequest200ResponseToJSONTyped(json, false);
}

export function CreateSupportRequest200ResponseToJSONTyped(value?: CreateSupportRequest200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': value['status'],
        'message': value['message'],
    };
}

